import { environment } from 'src/environments/environment';

export const PUBLIC_ENVIRONMENT_NAME_SUFFIX = '-public';

/**
 * True when running the public (`/web/`) build, i.e. an angular configuration named `*-public`
 * (see the `fileReplacements` in angular.json). Single source of truth for public-only behaviour.
 * The environment name can be passed explicitly for testing; it defaults to the active build.
 */
export const isPublicWebAppBuild = (environmentName: string = environment.name): boolean => {
  return environmentName.endsWith(PUBLIC_ENVIRONMENT_NAME_SUFFIX);
};
